/**
 * Helper per placeholder dinamici di targa e patente per il paese del documento.
 * Phase 38 — evita di confondere driver con documenti italiani vedendo solo esempi CH.
 */
export const DOC_COUNTRIES = [
  { id: "CH", label: "Svizzera" },
  { id: "IT", label: "Italia" },
  { id: "OTHER", label: "Altro" },
];

export const PLATE_PLACEHOLDER = {
  CH: "es. TI 123 456",
  IT: "es. AB 123 CD",
  OTHER: "es. targa veicolo",
};

export const LICENSE_PLACEHOLDER = {
  CH: "es. CH-1234567",
  IT: "es. AB1234567CD",
  OTHER: "es. numero patente",
};

export function platePlaceholder(country) {
  return PLATE_PLACEHOLDER[country] || PLATE_PLACEHOLDER.OTHER;
}
export function licensePlaceholder(country) {
  return LICENSE_PLACEHOLDER[country] || LICENSE_PLACEHOLDER.OTHER;
}
